import Flex from "@/components/Flex";
import Text from "@/components/Text";
import InfoOutlinedIcon from "@mui/icons-material/InfoOutlined";
import { SxProps, Theme } from "@mui/material";
import {
  CHAT_CONSENT_INFO,
  CONSENT_INFO_BG_COLOR,
  CONSENT_INFO_ICON_FONT_SIZE,
  CONSENT_INFO_LABEL,
  CONSENT_INFO_MIN_HEIGHT,
  CONSENT_INFO_TEXT_COLOR,
  SMS_CONSENT_INFO,
} from "./messages-constant";

export interface ConsentInfoBannerProps {
  content: string;
  sx?: SxProps<Theme>;
}

/**
 * Consent notice pinned to the bottom of its container so it stays visible
 * right above the compose/send area while the content above it scrolls.
 */
export const ConsentInfoBanner = ({ content, sx }: ConsentInfoBannerProps) => (
  <Flex
    bgcolor={CONSENT_INFO_BG_COLOR}
    minHeight={CONSENT_INFO_MIN_HEIGHT}
    alignItems={"center"}
    px={1}
    py={2}
    sx={{ position: "sticky", bottom: 0, zIndex: 1, ...sx }}
  >
    <Text variant="caption" color={CONSENT_INFO_TEXT_COLOR}>
      <Flex alignItems={"start"}>
        <Flex
          justifyContent={"center"}
          alignItems={"center"}
          gap={0.3}
          mr={0.5}
        >
          <InfoOutlinedIcon
            fontSize="small"
            style={{ fontSize: CONSENT_INFO_ICON_FONT_SIZE }}
          />
          <b>{CONSENT_INFO_LABEL}</b>
        </Flex>
        {content}
      </Flex>
    </Text>
  </Flex>
);

export const SmsConsentInfo = ({ sx }: { sx?: SxProps<Theme> }) => (
  <ConsentInfoBanner content={SMS_CONSENT_INFO} sx={sx} />
);

export const ChatConsentInfo = ({ sx }: { sx?: SxProps<Theme> }) => (
  <ConsentInfoBanner content={CHAT_CONSENT_INFO} sx={sx} />
);
